(function () {
  angular.module("akitabox.ui.dialogs.assemblyCondition", [
    "ngMaterial",
    "akitabox.core.constants",
    "akitabox.core.services.assembly",
    "akitabox.core.services.condition",
    "akitabox.core.toast",
  ]);
})();
